// Displayed like count: the REAL Roblox like total when available (our own
// likes are ~0 for fresh games), plus the viewer's own like on top of it.
// Falls back to the in-app count when Roblox telemetry is missing.
export function displayLikes(upVotes: number | null | undefined, likes: number, liked: boolean): string {
  const real = Number(upVotes) || 0;
  if (real > 0) return formatCompact(real + (liked ? 1 : 0));
  return formatCompact(likes);
}

// Absolute same-origin API path: immune to doubled/stale URL prefixes
// (/robloky/robloky/...) that would otherwise break relative fetches.
// Idempotent: the portal rewriter prefixes quoted "/robloky/api/..." literals in the
// served bundle, so the argument may ALREADY carry the prefix â€” never add it
// twice (that is what produced /robloky/robloky/... 404s on auth and
// comment calls).
export function apiUrl(p: string): string {
  if (p === '/robloky' || p.startsWith('/robloky/')) return p;
  return `${basePrefix()}${p}`;
}

// Tiny inline placeholder when a game image fails to load (never a broken icon).
export const IMG_FALLBACK =
  'data:image/svg+xml,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="768" height="432"><rect width="768" height="432" fill="#141a26"/><text x="384" y="216" font-family="monospace" font-size="28" font-weight="bold" fill="#3b475c" text-anchor="middle">NO IMAGE</text></svg>'
  );

export function handleImgError(e: { currentTarget: HTMLImageElement }) {
  const t = e.currentTarget;
  if (!t.src.startsWith('data:')) t.src = IMG_FALLBACK;
}

// Base prefix of the app URL. In production the service lives under
// /robloky/ (portal strips the prefix before proxying, but the browser
// URL keeps it); in local dev it is served from the domain root.
export function basePrefix(): string {
  try {
    const m = window.location.pathname.match(/^\/(robloky)(?=\/|$)/);
    return m ? `/robloky/${m[1]}` : '';
  } catch {
    return '';
  }
}
// Compact number formatting for stats (1.2K, 3.4M, 5.6B).
export function formatCompact(n: number | null | undefined): string {
  const v = Number(n) || 0;
  if (v >= 1_000_000_000) return `${(v / 1_000_000_000).toFixed(1).replace(/\.0$/, '')}B`;
  if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
  if (v >= 1_000) return `${(v / 1_000).toFixed(1).replace(/\.0$/, '')}K`;
  return String(v);
}

export function timeAgo(iso: string): string {
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return '';
  const s = Math.max(1, Math.floor((Date.now() - t) / 1000));
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 30) return `${d}d ago`;
  const mo = Math.floor(d / 30);
  if (mo < 12) return `${mo}mo ago`;
  return `${Math.floor(mo / 12)}y ago`;
}
